import { Grid, Stack, Typography } from "@mui/material";
import { Box, Container } from "@mui/system";
import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import CategoryItem from "./CategoryItem";
import { tokens } from "../../../store/tokens";

// Fallback data shown if the live endpoint is unreachable (kept as a real
// array now instead of an unparsed JSON string).
const FALLBACK_CATEGORIES = [
  { banner_pic: "https://ap.songjukti.com/image/catPic/creative_work.jpg", title: "Graphics Design", type: "Graphics Design", info: "Brand Your Business", subcat: "", total_listing: "164", category: "IJUWS5BE", refer: "1", state: "1" },
  { banner_pic: "https://ap.songjukti.com/image/web_event/catering.jpg", title: "Event", type: "International Corporate Event Organization", info: "Event Design & Organization", subcat: "", total_listing: "25", category: "TPKHNME3", refer: "6", state: "1" },
  { banner_pic: "https://ap.songjukti.com/image/web_writing/article_writing.jpg", title: "Writing", type: "Article Writing", info: "Article Writing", subcat: "", total_listing: "16", category: "48DG1PDD", refer: "8", state: "1" },
  { banner_pic: "https://ap.songjukti.com/image/web_marketing/promotion.jpg", title: "Brand Promotion", type: "Promotion", info: "Promoting business by brand expert", subcat: "", total_listing: "32", category: "LY1KJ2GA", refer: "7", state: "1" },
  { banner_pic: "https://ap.songjukti.com/image/web_mobile/android_native.jpg", title: "Nativ Android App", type: "Native App", info: "Build awesome native app for android OS", subcat: "", total_listing: "9", category: "91LQABKQ", refer: "3", state: "1" },
  { banner_pic: "https://ap.songjukti.com/image/catPic/creative_work.jpg", title: "Flayer Print", type: "DTP", info: "Give your promotional materials a professional edge.", subcat: "", total_listing: "43", category: "D8PKL7VI", refer: "5", state: "1" },
  { banner_pic: "https://ap.songjukti.com/image/web_law/taxaion.jpg", title: "Income Tax expert", type: "Lawyer", info: "Pay your tax with an authorised Income tax Lawyer", subcat: "", total_listing: "15", category: "7JF45AQ4", refer: "9", state: "1" },
  { banner_pic: "https://ap.songjukti.com/image/web_photograph/model_photo.jpg", title: "Model Photography", type: "Model Photography", info: "Wanna find a photgrapher for your modeling", subcat: "", total_listing: "29", category: "FI9UXNVY", refer: "11", state: "1" },
];

const gridContainer = { hidden: {}, visible: { transition: { staggerChildren: 0.07 } } };
const gridItem = { hidden: { opacity: 0, y: 20 }, visible: { opacity: 1, y: 0, transition: { duration: 0.4 } } };

const sectionTitleSx = {
  fontFamily: tokens.font.heading,
  fontWeight: tokens.type.h2.fontWeight,
  letterSpacing: tokens.type.h2.letterSpacing,
  fontSize: { xs: "1.7rem", md: tokens.type.h2.fontSize },
  lineHeight: tokens.type.h2.lineHeight,
  color: tokens.textOn.light.primary,
};
const sectionSubtitleSx = {
  fontFamily: tokens.font.body,
  fontSize: tokens.type.body1.fontSize,
  lineHeight: tokens.type.body1.lineHeight,
  color: tokens.textOn.light.secondary,
  maxWidth: 560,
};

const Categories = () => {
  const [categoryData, setCategoryData] = useState([]);

  useEffect(() => {
    fetch("//aps.songjukti.com/profile/login/api_webland/top_category.php", {
      method: "GET",
    })
      .then((res) => res.text())
      .then((text) => {
        try {
          const json = JSON.parse(text);
          setCategoryData(Array.isArray(json) && json.length ? json : FALLBACK_CATEGORIES);
        } catch (err) {
          console.error("JSON parse error", err);
          setCategoryData(FALLBACK_CATEGORIES);
        }
      })
      .catch((error) => {
        console.log("Fetch Error => ", error);
        setCategoryData(FALLBACK_CATEGORIES);
      });
  }, []);

  return (
    <Container>
      {categoryData.length > 1 && (
        <Box mt={{ xs: 6, md: 8 }}>
          <Stack
            component={motion.div}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.5 }}
            justifyContent="center"
            alignItems="center"
            sx={{ px: 2, textAlign: "center", gap: 1.25, mb: { xs: 3, md: 4 } }}
          >
            <Typography sx={sectionTitleSx}>Trending top categories</Typography>
            <Typography sx={sectionSubtitleSx}>
              A large, globally spread network of talented people
            </Typography>
          </Stack>

          <Grid
            container
            spacing={2}
            component={motion.div}
            variants={gridContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.15 }}
          >
            {categoryData.slice(0, 8).map((element) => (
              <Grid
                item
                xs={6}
                sm={4}
                md={3}
                key={element.refer}
                component={motion.div}
                variants={gridItem}
                whileHover={{ y: -4 }}
              >
                <CategoryItem data={element} />
              </Grid>
            ))}
          </Grid>
        </Box>
      )}
    </Container>
  );
};

export default Categories;